'use client';

import { Button } from '@/components/core/Button/Button';
import { useTranslation } from '@app/i18n/client';
import { signOut } from 'next-auth/react';
import { FC, useState } from 'react';
import Spinner from '../Spinner/Spinner';

export const LogoutButton: FC = () => {
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = useState(false);

	const handleSignOut = async () => {
		setIsLoading(true);
		try {
			await signOut({ callbackUrl: '/' });
		} catch (error) {
			setIsLoading(false);
		}
	};

	return (
		<Button
			type="submit"
			variant="ghost"
			onClick={handleSignOut}
			icon={isLoading ? <Spinner size="sm" /> : undefined}
			disabled={isLoading}
		>
			{t('global.logout')}
		</Button>
	);
};
